import PhotoSwipe from "photoswipe";

class Lightbox {
  options = {
    index: 0,
    dataSource: [],
    mainClass: "pswp--wyss",
    opacity: 1,
    bgOpacity: 0.9,
    closeOnVerticalDrag: false,
  };

  type = null;

  pswp = null;

  constructor($el) {
    this.$el = $el;
    this.$items = $el.find('[data-lightbox="item"]');
    this.init();
  }

  init = () => {
    this.prepareDataSource();

    this.$el.on("click", this.initLightbox);
  };

  prepareDataSource = () => {
    // get data source from data-lightbox-item
    this.$items.each((index, item) => {
      const $item = $(item);
      let data = null;
      let template = null;
      let html = null;

      this.type = $item.data("type");

      switch (this.type) {
        case "image":
          data = {
            src: $item.data("pswp-src"),
            width: $item.data("pswp-width"),
            height: $item.data("pswp-height"),
            alt: $item.attr("alt"),
          };
          break;
        case "video":
          template = $($item.data("pswp-src"))[0];
          html = template.innerHTML;
          data = {
            html: template.innerHTML,
            width: $item.data("pswp-width"),
            height: $item.data("pswp-height"),
          };
          break;
        case "html":
          template = $($item.data("pswp-src"))[0];
          html = template.innerHTML;
          data = {
            html,
          };
          this.options.mainClass = "pswp--wyss pswp--html";
          break;
      }

      this.options.dataSource.push(data);
    });
  };

  initLightbox = () => {
    this.pswp = new PhotoSwipe(this.options);

    if (this.type === "html") {
      this.pswp.on("beforeOpen", () => {
        $("html").addClass("no-scroll");
      });

      this.pswp.on("close", () => {
        $("html").removeClass("no-scroll");
      });
    }

    this.pswp.init(); // initializing PhotoSwipe core adds it to DOM

    if (this.type === "html") {
      $(this.pswp.container).on("wheel mousewheel DOMMouseScroll", (e) => {
        // Stop the event propagation bubbling up to the existing photoswipe listener.
        e.stopPropagation();
      });
    }
  };
}

export default Lightbox;
